module.exports = __webpack_public_path__ + "img/hocbg.54774475.jpg";